import ScrollPage, {
  SectionItem,
} from "../../Components/ScrollPage/ScrollPage";
import Section from "../../Components/Section/Section";
import BostonContent from "./BostonContent";

interface ScrollTo {
  index: number;
}

export const Sections: SectionItem[] = [{ label: "Boston", id: "wankel" }];

const Boston: React.FC<ScrollTo> = ({ index }) => (
  <ScrollPage index={index} sections={Sections}>
    <Section section={Sections[0].id}>
      <BostonContent />
    </Section>
  </ScrollPage>
);

export default Boston;
